import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { useToast } from '../../../contexts/ToastContext';

const ProjectSaver = ({ projectData, onDataChange, costs, onSave }) => {
  const { success } = useToast();
  const [isSaving, setIsSaving] = useState(false);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(value || 0);
  };

  const handleSave = async () => {
    if (!projectData?.name?.trim()) {
      onDataChange('name', 'Projeto ' + new Date()?.toLocaleDateString('pt-BR'));
    }
    
    setIsSaving(true);
    
    setTimeout(() => {
      onSave(projectData?.name || 'Projeto ' + new Date()?.toLocaleDateString('pt-BR'));
      setIsSaving(false);
    }, 1000);
  };

  const isProjectComplete = costs?.total > 0 && projectData?.name;
  // Permite salvar mesmo sem nome (vamos gerar um nome padrão)
  const canSave = costs?.total > 0;

  return (
    <div className="bg-card border border-border rounded-xl p-8">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
          <Icon name="Save" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Salvar Projeto</h3>
          <p className="text-sm text-muted-foreground">Insira o nome e salve</p>
        </div>
      </div>
  {/* Campo de nome movido para Informações do Projeto */}
  {/* Action Buttons */}
  <div className="space-y-3">
    <Button
      onClick={handleSave}
      disabled={!canSave || isSaving}
      className="w-full flex items-center justify-center space-x-2"
    >
          {isSaving ? (
            <>
              <motion.div
                className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full"
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
              />
              <span>Salvando...</span>
            </>
          ) : (
            <>
              <Icon name="Save" size={16} />
              <span>Salvar Projeto</span>
            </>
          )}
        </Button>

        <Button
          variant="outline"
          disabled={!canSave}
          className="w-full flex items-center justify-center space-x-2"
          onClick={() => {
            // Mock export functionality
            const exportData = {
              name: projectData?.name,
              finalPrice: costs?.finalPrice,
              breakdown: costs,
              timestamp: new Date()?.toISOString()
            };
            console.log('Exporting:', exportData);
            success('Orçamento exportado com sucesso!');
          }}
        >
          <Icon name="Download" size={16} />
          <span>Exportar Orçamento</span>
        </Button>
      </div>
      {/* Informações detalhadas removidas para evitar redundância; o resumo cobre esses dados */}
      {/* Tips */}
      <div className="mt-6 p-3 bg-muted/20 rounded-xl">
        <div className="flex items-start space-x-2">
          <Icon name="Lightbulb" size={16} className="text-primary flex-shrink-0 mt-0.5" />
          <div className="text-xs text-muted-foreground">
            <p className="font-medium text-foreground mb-1">Dica:</p>
            <p>
              Salve seus projetos para comparar preços e reutilizar configurações em trabalhos futuros.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSaver;